//
// Javascript tools for determining the
// current context whether production, stage or development
//
//  Ben Ramey
//  March 2010
//
HEIJS = typeof (HEIJS) == "undefined" ? {} : HEIJS;
HEIJS.Context = function () {
  this.absoluteUri = document.location.href;
  this.contextHost = this.getHost(this.absoluteUri);
};

HEIJS.Context.prototype = {
  //
  //  Properties
  //
  applicationID: null,
  domainPattern: /^https?:\/\/([^\/:]+)/,
  absoluteUri: null,
  contextHost: null,
  contextMapping: {
      "production2": ".hei-eng.com",
      "development": ".dev.hendersonengineers.com",
      "production": ".hendersonengineers.com",
      "stage": ".hendersonstage.com"
  },
  _appsContext : null,

  
  //
  //  Methods
  //
  init: function () {
    this.applicationID = $("input[id$=MembershipApplicationID]").val();
  },

  convertToContextUri: function (uri) {
    // prevents non-hei urls from being converted to hei urls, such as www.google com was turning into test.com
    if (this.isContextUri(uri)) {
      if (this.isAppsContext()) {
        if (uri.toLowerCase().indexOf("www.") !== -1 && (uri.toLowerCase().indexOf("/resources/") !== -1 || uri.toLowerCase().indexOf("/floormaps/") !== -1)) {
          uri = uri.replace("www.", "apps.");
        }
      }
      
      if (uri.toLowerCase().indexOf('concur.') === -1 &&
          uri.toLowerCase().indexOf('ultipro.') === -1) {
        uri = uri.replace(this.contextMapping['development'], this.contextMapping['production']); //this ensures that replacing the production pattern below works correctly and we don't double-convert any dev urls. 
		for (var d in this.contextMapping) {
          uri = uri.replace(this.contextMapping[d], this.contextHost);
        }
      }
    }
    
    return uri;
  },

  isContextUri: function (uri) {
    for (var d in this.contextMapping) {
      if (uri.indexOf(this.contextMapping[d]) > -1) {
        return true;
      }
    }
    return false;
  },

  isAppsContext: function() {
      for (var environment in this.contextMapping) {
          //environment "2" means that it doesn't use apps.test.com for resources
          if (environment.indexOf("2") !== -1 && this.contextHost.toLowerCase().indexOf(this.contextMapping[environment]) !== -1) {
              return false;
          }
      }
      return true;
  },

  getResourceUri: function (resourceRelativePath) {
    if (resourceRelativePath.indexOf("/") !== 0) {
      resourceRelativePath = "/" + resourceRelativePath;
    }

    return this.convertToContextUri("https://apps.hendersonengineers.com" + resourceRelativePath);
  },

  getHost: function (uri) {
    var host = uri.match(this.domainPattern);

    if (host == null) {
      return "";
    }

    host = host[1];

    /* if the above got something like "xnet.hei-eng.com" (most often the case)
    then take only the last two parts so contextHost becomes ".hei-eng.com" */
    var uriParts = host.split(".");
	if (uriParts.length >= 3) {
	  host = "";
	  for (var i = 1; i < uriParts.length; i++) {
	    host = host + "." + uriParts[i];
	  }
    }

    if (/localhost/i.test(host)) {
      host = '.dev.hendersonengineers.com';
    }

    return host;
  },

  getContextHost: function () {
    return this.contextHost;
  },

  getProductionUri: function () {
    return this.contextMapping["production"];
  },

  getStageUri: function () {
    return this.contextMapping["stage"];
  },

  getDevelopmentUri: function () {
    return this.contextMapping["development"];
  },

  isProduction: function () {
    return this.isContext("production");
  },

  isStage: function () {
    return this.isContext("stage");
  },

  isDevelopment: function () {
    return this.isContext("development");
  },

  isContext: function (contextName) {
    if (this.contextHost == this.contextMapping[contextName]) {
      return true;
    }

    return false;
  },

  isSecure: function () {
    if (document.location.protocol == "https:") {
      return true;
    }

    return false;
  },

  getContextName: function () {
    for (var key in this.contextMapping) {
      if (this.contextMapping[key] == this.contextHost) {
        return key;
      }
    }

    return "unknown";
  }
};